module.exports = __webpack_public_path__ + "img/activities.6f973925.svg";